/**
 * One loader per animation. Each JSON becomes its own chunk, fetched the first
 * time an icon with that name comes into view, instead of all of them riding
 * along in the shared bundle of every page that renders any icon.
 */
export const animatedIcons = {
  share: () => import('@assets/lottie/share.json'),
  star: () => import('@assets/lottie/star.json'),
  'star-filled': () => import('@assets/lottie/star-filled.json'),
  'star-transition': () => import('@assets/lottie/star-transition.json'),
  settings: () => import('@assets/lottie/settings.json'),
  'settings-filter': () => import('@assets/lottie/settings-filter.json'),
  'arrow-right': () => import('@assets/lottie/arrow-right.json'),
  visibility: () => import('@assets/lottie/visibility.json'),
  'edit-pencil': () => import('@assets/lottie/edit-pencil.json'),
  swap: () => import('@assets/lottie/swap.json'),
  download: () => import('@assets/lottie/download.json'),
  cancel: () => import('@assets/lottie/cancel.json'),
  clean: () => import('@assets/lottie/clean.json'),
  notification: () => import('@assets/lottie/notification.json'),
  'price-alert': () => import('@assets/lottie/price-alert.json'),
  bookmark: () => import('@assets/lottie/bookmark.json'),
  'nav-fire': () => import('@assets/lottie/nav/fire.json'),
  'nav-card-flip': () => import('@assets/lottie/nav/card-flip.json'),
} as const;

export type AnimatedIconName = keyof typeof animatedIcons;
